import { ReactNode, FC, PropsWithChildren, MouseEventHandler } from 'react';
import { useMediaQuery } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


type Props = DialogProps & PropsWithChildren<{
  title: ReactNode,
}>

export const InfoDialog: FC<Props> = ({ children, title, id, ...dialogProps }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handleCloseClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    dialogProps.onClose?.(event, 'backdropClick');
  };

  return (
    <Dialog
      aria-labelledby={id}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      open={dialogProps.open}
      onClose={dialogProps.onClose}
    >
      <DialogTitle id={id}>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleCloseClick}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        {children}
      </DialogContent>
    </Dialog>
  );
};
